
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solar-panel-sell",
      function () {
        return require("private-next-pages/solar-panel-sell/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solar-panel-sell"])
      });
    }
  